import { render, staticRenderFns } from "./drawPicture.vue?vue&type=template&id=38d1c95d&scoped=true"
import script from "./drawPicture.vue?vue&type=script&lang=js"
export * from "./drawPicture.vue?vue&type=script&lang=js"
import style0 from "./drawPicture.vue?vue&type=style&index=0&id=38d1c95d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d1c95d",
  null
  
)

export default component.exports